import { Controller } from "@hotwired/stimulus"
import { Chart, ArcElement, Tooltip, Legend, PieController } from 'chart.js'

// Register Chart.js components
Chart.register(ArcElement, Tooltip, Legend, PieController)

export default class extends Controller {
  static values = {
    data: Object,
    year: String
  }

  connect() {
    console.log('🚀 FinancialChartsController v1.1 loaded - numeric values fix')
    this.renderChart()
  }

  renderChart() {
    if (!this.dataValue || !this.dataValue.labels || !this.dataValue.values) {
      console.warn('Chart data not available', this.dataValue)
      return
    }

    // this.element IS the canvas when data-controller is on the canvas tag
    const ctx = this.element

    // Destroy existing chart if it exists
    if (this.chart) {
      this.chart.destroy()
    }

    // Ensure values are numbers (Ruby BigDecimal may serialize as strings)
    const numericValues = this.dataValue.values.map(v => Number(v) || 0)

    this.chart = new Chart(ctx, {
      type: 'pie',
      data: {
        labels: this.dataValue.labels,
        datasets: [{
          data: numericValues,
          backgroundColor: [
            '#4A4A4A', // Dark gray
            '#6B6B6B', // Medium gray
            '#8C8C8C', // Light gray
            '#ADADAD', // Lighter gray
            '#CECECE'  // Lightest gray
          ],
          borderWidth: 0,
          borderColor: 'transparent'
        }]
      },
      options: {
        responsive: true,
        maintainAspectRatio: true,
        elements: {
          arc: {
            borderWidth: 0,
            borderColor: 'transparent'
          }
        },
        plugins: {
          legend: {
            position: 'bottom',
            labels: {
              padding: 15,
              font: {
                size: 12
              },
              generateLabels: (chart) => {
                const data = chart.data
                const dataset = data.datasets[0]
                const total = dataset.data.reduce((a, b) => a + b, 0)
                return data.labels.map((label, i) => {
                  const value = dataset.data[i]
                  const percentage = total > 0 ? ((value / total) * 100).toFixed(1) : 0

                  return {
                    text: `${label}: ${percentage}%`,
                    fillStyle: dataset.backgroundColor[i],
                    strokeStyle: 'transparent',   // 👈 FIX: remove stroke
                    lineWidth: 0,                 // 👈 FIX: no border
                    hidden: false,
                    index: i
                  }
                })
              }
            }
          },
          tooltip: {
            callbacks: {
              label: function(context) {
                const label = context.label || ''
                const value = context.parsed || 0
                const total = context.dataset.data.reduce((a, b) => a + b, 0)
                const percentage = ((value / total) * 100).toFixed(1)
                return `${label}: ${percentage}%`
              }
            }
          }
        }
      }
    })
  }

  disconnect() {
    if (this.chart) {
      this.chart.destroy()
    }
  }
}
